module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/partners-06-b7dd936fdb5410b7a96f26a93a7eafbb.png";